import React from "react"
import { AutocompleteAjaxSeeker, IconSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData, } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { Box, Typography } from "@mui/material"
import { alertsSection } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"


export default function AlertsComparator({ ...props }) {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().comparator || 0)

	const getAlertConfig = (alertsSectionValue) => {
		if (alertsSectionValue === ALERTS.PRICE_CHANGE) {
			return {
				1: { icon: "arrow-down", label: "Price Decrease", color: "error.main" },
				0: { icon: "arrow-up", label: "Price Increase", color: "success.main" },
				2: { icon: "arrow-down-arrow-up", label: "Price Difference", color: "warning.main" }
			}
		}
		if (alertsSectionValue === ALERTS.PRICE_COMPARISON) {
			return {
				0: { icon: "chart-line-up", label: "More Expensive", color: "success.main" },
				1: { icon: "chart-line-down", label: "Cheaper", color: "error.main" },
				2: { icon: "chart-line-up-down", label: "Price Difference", color: "warning.main" }
			}
		}
		if (alertsSectionValue === ALERTS.MIN_MAX_PRICE) {
			return {
				1: { icon: "coins", label: "Cheapest", color: "warning.main" },
				0: { icon: "gem", label: "Most expensive", color: "colors.purple" },
			}
		}
	}

	const labelsFormatted = getAlertConfig(alertsSection.value)


	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		disableClearable
		inputProps={{
			startAdornment: <IconSeeker
				icon={labelsFormatted[dataInfo.value].icon}
				sx={{
					color: labelsFormatted[dataInfo.value].color,
					ml: 1,
					mr: .5
				}}
			/>
		}}
		onAjax={options => {
			return options.map(({ value }) => ({
				value: value,
				label: labelsFormatted[value].label,
			}))
		}}
		formatOptionLabel={({ value }) => {
			return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
				<IconSeeker
					icon={labelsFormatted[value].icon}
					sx={{ color: labelsFormatted[value].color }}
				/>
				<Typography>{labelsFormatted[value].label}</Typography>
			</Box>
		}
		}
		label="Comparator"
		placeholder="Way of comparison"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/comparator`}
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'comparator')}
		{...props}
	/>
}